export const default_colors = {
  primary_color: "#F2E94E",
  secondary_color: "#000000",
  page_background_color: "#FFFFFF",
  button_text_color: "#000000",
};

export const default_template_colors = {
  "template-primary-color": "#F2E94E",
  "template-secondary-color": "#000000",
  "template-page-background": "#FFFFFF",
  "template-primary-button-text-color": "#000000",
};

export const template_color_key_prefix = "template-";

export const color_picker_debounce_ms = 500;

export const default_hex_color = "#000000";

export const mapped_color_keys = Object.keys(default_colors);

export const template_color_keys = Object.keys(default_template_colors);
